var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCampfireProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "campfire_profile_",
    "data-name": "campfire profile ",
    transform: "translate(-453 -315)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_143",
    "data-name": "Elipse 143",
    transform: "translate(453 315)",
    fill: "#f2f2f2",
    stroke: "gray",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Campfire_logo",
    "data-name": "Campfire logo",
    d: "M783.346,292.636s-6.42-3.1-3.745-11.372a17.614,17.614,0,0,1,2.953-4.884c2.425-3.132,3.1-8.934,3.1-10.622a.38.38,0,0,1,.57,0c.35.281,1.489,1,2.767,3.922a12.218,12.218,0,0,1,.739,3.752c.028,1.932.256,5.03,1.137,5.03s.995-1.336.995-3.069c0,0,.2-.512.711.057a14.066,14.066,0,0,1,2.976,11s-.4,4.806-4.464,6.185c0,0-.549-.061-.2-.743s1.037-1.278.542-4.3a9.741,9.741,0,0,0-1.983-4.013,27.119,27.119,0,0,1-2.526-5.5s-3,6.066-3.777,7.955-.59,4.98.59,6.09C783.731,292.126,784,292.636,783.346,292.636Z",
    transform: "translate(-312.07 58.091)",
    fill: "#aaa"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampfireProfile);
export default __webpack_public_path__ + "static/media/campfire_profile.750751ddb0b6d55467d648930cb06444.svg";
export { ForwardRef as ReactComponent };